import i18n from '../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";

export default class PreBidsModal extends BaseModel {
  paddle_number = null;
  clerk_assignment_lock = false;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    paddle_number: 'required'
  };

  attributeLabels = {
    paddle_number: i18n.t('Paddle Number')
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(PreBidsModal);
